var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 4.5,
    stroke: "#ED1F24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4374 11.7746V18.6215H17.5646V11.7746H10.4374ZM9.41895 10.7961H18.582V18.6215C18.582 18.7499 18.5557 18.8772 18.5045 18.9959C18.4533 19.1146 18.3783 19.2224 18.2837 19.3133C18.1891 19.4041 18.0769 19.4762 17.9533 19.5254C17.8297 19.5746 17.6973 19.5999 17.5636 19.5999H10.4374C10.1673 19.5999 9.90824 19.4968 9.71725 19.3133C9.52625 19.1298 9.41895 18.8809 9.41895 18.6215V10.7961Z",
    fill: "#ED1F24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6004 10.7961H8.40039V11.7746H19.6004V10.7961Z",
    fill: "#ED1F24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4551 12.752V17.6431H12.4735V12.752H11.4551Z",
    fill: "#ED1F24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4912 12.752V17.6431H14.5097V12.752H13.4912Z",
    fill: "#ED1F24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5273 12.752V17.6431H16.5458V12.752H15.5273Z",
    fill: "#ED1F24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5322 10.7962H15.5148C15.5148 10.7962 15.5148 9.83258 15.5148 9.43747C15.483 9.41423 15.4485 9.39441 15.4122 9.37835H12.5168C12.3728 9.36338 12.2274 9.39123 12.1004 9.45816V10.7962H11.083V9.39603C11.083 9.04822 11.3906 8.3999 12.5188 8.3999H15.5722L15.64 8.41764C15.879 8.46743 16.0951 8.58915 16.257 8.76512C16.419 8.94109 16.5183 9.16211 16.5405 9.39603C16.5333 9.76158 16.5322 10.7962 16.5322 10.7962Z",
    fill: "#ED1F24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBtn);
export default __webpack_public_path__ + "static/media/Trash_Btn.e412c0ee.svg";
export { ForwardRef as ReactComponent };